export default __webpack_public_path__ + "static/website1-eb09dee0e0404e616e7aae6c83456695.png";